import React from "react";
import PageHeader from "../../../../../components/reusable/management/PageHeader";

// const buttonStyle = {
//     padding: "10px 16px",
//     border: "1px solid #d1d5db",
//     background: "#fff",
//     borderRadius: "10px",
//     cursor: "pointer",
//     fontWeight: 600,
//     transition: "0.2s",
// };

const FirmDashboardHeader = () => {
    return (
        // <div
        //     style={{
        //         display: "flex",
        //         justifyContent: "space-between",
        //         alignItems: "center",
        //         flexWrap: "wrap",
        //         gap: "20px",
        //         marginBottom: "24px",
        //     }}
        // >
        //     {/* Left Side */}
        //     <div>
        //         <h1
        //             style={{
        //                 margin: 0,
        //                 fontSize: "30px",
        //                 color: "#0f172a",
        //             }}
        //         >
        //             🏢 Firm Dashboard
        //         </h1>

        //         <p
        //             style={{
        //                 marginTop: "8px",
        //                 color: "#64748b",
        //                 fontSize: "15px",
        //             }}
        //         >
        //             Manage your firm's departments, offices, employees and organizational structure.
        //         </p>
        //     </div>

        //     {/* Right Side */}
        //     <div
        //         style={{
        //             display: "flex",
        //             gap: "12px",
        //             flexWrap: "wrap",
        //         }}
        //     >
        //         <button
        //             style={buttonStyle}
        //             onMouseEnter={(e) => {
        //                 e.currentTarget.style.background = "#eff6ff";
        //                 e.currentTarget.style.borderColor = "#3b82f6";
        //             }}
        //             onMouseLeave={(e) => {
        //                 e.currentTarget.style.background = "#fff";
        //                 e.currentTarget.style.borderColor = "#d1d5db";
        //             }}
        //         >
        //             + Employee
        //         </button>

        //         <button
        //             style={buttonStyle}
        //             onMouseEnter={(e) => {
        //                 e.currentTarget.style.background = "#ecfdf5";
        //                 e.currentTarget.style.borderColor = "#10b981";
        //             }}
        //             onMouseLeave={(e) => {
        //                 e.currentTarget.style.background = "#fff";
        //                 e.currentTarget.style.borderColor = "#d1d5db";
        //             }}
        //         >
        //             + Department
        //         </button>

        //         <button
        //             style={buttonStyle}
        //             onMouseEnter={(e) => {
        //                 e.currentTarget.style.background = "#fef3c7";
        //                 e.currentTarget.style.borderColor = "#f59e0b";
        //             }}
        //             onMouseLeave={(e) => {
        //                 e.currentTarget.style.background = "#fff";
        //                 e.currentTarget.style.borderColor = "#d1d5db";
        //             }}
        //         >
        //             + Office
        //         </button>
        //     </div>
        // </div>
        <PageHeader
            title    = "🏢 Firm Dashboard"
            subtitle = "Manage your firm's departments, offices, employees and organizational structure."

            actions = {[
                {
                    label: "Employee",
                    icon: "+",
                    // onClick: () => {},
                },
                {
                    label: "Department",
                    icon: "+",
                    // onClick: () => {},
                },
                {
                    label: "Office",
                    icon: "+",
                    // onClick: () => {},
                },
            ]}
        />
    );
};

export default FirmDashboardHeader;
